import {googleAds} from '../../../externalTrackers/index.js'
import {checkEmailLeadEvent} from '../../../utils.js'

const CONVERSION_ID = 'AW-860166335'
const DEFAULT_CONVERSION_LABEL = 'LDlbCPXS94UBEL-xlJoD'

const track = googleAds({id: CONVERSION_ID})

const getLabel = ({isEmailLeadEvent}) => (isEmailLeadEvent ? 'jmW-CMTq3oUBEL-xlJoD' : DEFAULT_CONVERSION_LABEL)

export default ({event, properties, isPage}) => {
  const isEmailLeadEvent = checkEmailLeadEvent({event, properties})
  const label = getLabel({isEmailLeadEvent})
  const needsToTrack = isPage || isEmailLeadEvent

  needsToTrack && track({label})
  isPage && track({event: 'page_view', allowAdPersonalization: true})
}
